import {Component, Input} from '@angular/core';
import {Router} from '@angular/router';
import {NgbModalRef} from '@ng-bootstrap/ng-bootstrap/modal/modal-ref';
import {AssignmentModel} from '../../../models/assignment.model';
import {MemberModel} from '../../../models/user.model';
import {CrmService} from '../../../services/api/crm.service';
import {HelpersService} from '../../../services/helpers.service';
import {MemberService} from '../../../services/member.service';
import {ModalService} from '../../../services/modal/modal.service';
import {AlertService} from '../../../services/notify/alert.service';

@Component({
    selector: 'app-all-assignments',
    templateUrl: './all-assignments.component.html',
    styleUrls: ['./all-assignments.component.scss']
})
export class AllAssignmentsComponent {
    @Input() headerVisible = true;

    public currentMember: MemberModel;
    public assignments: AssignmentModel[];
    public description: string = null;
    public selectedAssignment: AssignmentModel;
    private pagination = {
        currentPage: 1,
        archived: false,
        limit: 20,
    };

    constructor(
        private memberService: MemberService,
        private tasksService: CrmService,
        private alertService: AlertService,
        public helpers: HelpersService,
        public router: Router,
        public modalService: ModalService,
    ) {
        this.getMember();
    }

    getMember(): void {
        this.memberService.getCurrentMember().then(member => {
            this.currentMember = member;
            this.getAssignments();
        });
    }

    getAssignments(): void {
        this.tasksService.getAssignments(this.currentMember.guid, this.pagination).subscribe(res => {
            this.assignments = res.data;

            let membersGuids: string[] = [];
            this.assignments.forEach(assignment => {
                membersGuids.push(assignment.author_guid);
            });
            this.memberService.memberGuidsHandler(membersGuids).then(members => {
                this.assignments = this.assignments.map(assignment => {
                    assignment.author = members.find(x => x.guid === assignment.author_guid);
                    return assignment;
                });
            });
        });
    }

    createAssignment(name: string, modal: NgbModalRef): void {
        const data = {
            title: name,
            content: this.description,
        };
        this.tasksService.createAssignment(data).subscribe({
            next: () => {
                this.getAssignments();
                modal.close();
                this.description = null;
            }, error: err => {
                this.alertService.setAlert(err.message, 'blue');
            }
        });
    }

    changeAssignment(assignment: any): void {
        if (this.selectedAssignment && this.selectedAssignment.id === assignment.id) {
            void this.router.navigate(['account', 'assignments', 'all', this.selectedAssignment.id]);
        } else {
            this.selectedAssignment = assignment;
        }
    }
}
